import { useTranslation } from 'react-i18next';
import { FieldError } from '~/components/ui/inputs/FieldError';
import type { SelectionConflict } from '~/pages/buy-lists/sections/selectionConflicts';

type SelectionConflictMessagesProps = {
  id: string;
  testId: string;
  conflicts: SelectionConflict[];
};

const conflictKey = (conflict: SelectionConflict) =>
  conflict.reason === 'lengthInAnotherSelectedLine'
    ? `${conflict.reason}-${conflict.lengthLabel}`
    : conflict.reason;

export function SelectionConflictMessages({
  id,
  testId,
  conflicts,
}: Readonly<SelectionConflictMessagesProps>) {
  const { t } = useTranslation('inventory');
  const conflictMessage = (conflict: SelectionConflict) =>
    conflict.reason === 'multipleCannedTalliesForProduct'
      ? t(
          'inventory.buy_list.tally_selection.conflict_multiple_canned_tallies_for_product'
        )
      : t(
          'inventory.buy_list.tally_selection.conflict_length_in_another_selected_line',
          { length: conflict.lengthLabel }
        );

  return (
    <div id={id} className="flex flex-col gap-1" data-testid={testId}>
      {conflicts.map((conflict) => (
        <FieldError key={conflictKey(conflict)} tone="warning">
          {conflictMessage(conflict)}
        </FieldError>
      ))}
    </div>
  );
}
